import React, { ReactNode } from 'react'

import Box from 'components_new/atoms/Box'

interface GenericWidgetBodyProps {
  children: ReactNode
}

const GenericWidgetBody = (props: GenericWidgetBodyProps) => {
  const { children } = props

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {children}
    </Box>
  )
}

export default GenericWidgetBody
